<div class="pdf-page app-aul-022-24" id="aul02224">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b>
      VIRTUAL CURRENCY<br />
      PROPERTY NOT COVERED
    </b>
  </p>

  <p class="font-medium">
    <b> THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <br />
  <p class="font-small">
    This endorsement modifies insurance provided under the following forms.
    <br />
    BUILDING AND PERSONAL PROPERTY COVERAGE FORM<br />
    CONDOMINIUM ASSOCIATION COVERAGE FORM
  </p>
  <p class="font-small">
    The following property is added to<b> A. Coverage</b>, paragraph
    <b>2. Property Not Covered </b>
  </p>
  <p class="font-small">
    Covered Property does not include virtual currency of any kind, by whatever
    name known, whether actual or fictitious including, but not limited to any
    digital currency, cryptocurrency or any other type of electronic currency.
  </p>
  <br />
  <br />
  <br />
  <p class="font-small">
    <b>All other terms and conditions of this policy remain unchanged.</b>
  </p>
</div>
